<template>
  <div class="form__group--border py-16 pb-32">
    <legend class="form__label pb-4">Maximum pets you'll watch at one time</legend>
    <poppins-dropdown
      id="number-of-pets"
      ref="maxPets"
      v-model="maxNumberOfPets"
      labelName="# of pets"
      :options="options"
      :status="formStatuses.maxNumberOfPets"
      :helperText="helperText(formStatuses.maxNumberOfPets)"
      @blur="validate"
    />
  </div>
</template>

<script lang="ts">
import helperStatus from '@/helpers/status';
import Dropdown from '@/components/dropdown/Dropdown.vue';

export default {
  name: 'MaxPetsSelect',
  components: {
    PoppinsDropdown: Dropdown,
  },
  data(): any {
    return {
      form: {
        maxNumberOfPets: undefined,
      },
      formStatuses: {
        maxNumberOfPets: helperStatus.Neutral,
      },
      options: [
        {
          value: '1',
          display: '1 pet',
        },
        {
          value: '2',
          display: '2 pets',
        },
        {
          value: '3',
          display: '3 pets',
        },
        {
          value: '4',
          display: '4+ pets',
        },
      ],
    };
  },
  computed: {
    maxNumberOfPets: {
      get() {
        return this.$store.getters.getFormField('maxNumberOfPets');
      },
      set(newValue) {
        this.formStatuses.maxNumberOfPets = helperStatus.Neutral;
        return this.$store.dispatch('updateForm', { key: 'maxNumberOfPets', value: newValue });
      },
    },
    fieldIsValid(): boolean {
      return !!this.maxNumberOfPets;
    },
  },
  methods: {
    validate() {
      if (!this.fieldIsValid) {
        this.formStatuses.maxNumberOfPets = helperStatus.Error;
      }
      return this.formStatuses.maxNumberOfPets;
    },
    helperText(status: helperStatus) {
      if (status === helperStatus.Error) {
        return `Select the most pets you're prepared to care for`;
      }
      return '';
    },
    focusElement() {
      this.$refs.maxPets.$el.querySelector('select')?.focus();
    },
  },
};
</script>
